import { CaseItemRarity } from '~/shared';
import { createSlice } from '../wrappers';

export interface IModalBuyDonateItem {
	id: string;
	name: string;
	amount: number;
	price: number;
	oldPrice?: number;
}

export interface IModalBuyInventoryItem {
	donateItemId: string;
	name: string;
	price: number;
	oldPrice?: number;
	imageId: string;
	type: 'vehicle' | 'clothes';
	rarity?: CaseItemRarity | null;
	discount?: number | null;
	discountTimestampEnd?: number | null;
}

export interface IShopSlice {
	shopKitOpen: boolean;
	shopPlayerItemsOpen: boolean;
	shopOpenCaseVisible: boolean;
	modalBuyType: 'vehicle' | 'clothes' | 'donate';
	modalBuyDonateItem: IModalBuyDonateItem | null;
	modalBuyInventoryItem: IModalBuyInventoryItem | null;
}

const initialState: IShopSlice = {
	shopKitOpen: false,
	shopPlayerItemsOpen: false,
	shopOpenCaseVisible: false,
	modalBuyType: 'donate',
	modalBuyDonateItem: null,
	modalBuyInventoryItem: null,
};

const shopSlice = createSlice({
	name: 'shop',
	initialState,
	reducers: {
		setShopKitOpen: (state, action) => {
			state.shopKitOpen = action.payload;
		},
		setShopPlayerItemsOpen: (state, action) => {
			state.shopPlayerItemsOpen = action.payload;
		},
		setShopOpenCaseVisible: (state, action) => {
			state.shopOpenCaseVisible = action.payload;
		},
		setModalBuyType: (state, action) => {
			state.modalBuyType = action.payload;
		},
		setModalBuyDonateItem: (state, action) => {
			state.modalBuyDonateItem = action.payload;
		},
		setModalBuyInventoryItem: (state, action) => {
			state.modalBuyInventoryItem = action.payload;
		},
		resetShopState: (state) => {
			state.shopKitOpen = false;
			state.shopPlayerItemsOpen = false;
			state.shopOpenCaseVisible = false;
			state.modalBuyType = 'donate';
			state.modalBuyDonateItem = null;
			state.modalBuyInventoryItem = null;
		},
	},
});

export const {
	setShopKitOpen,
	setShopPlayerItemsOpen,
	setShopOpenCaseVisible,
	setModalBuyType,
	setModalBuyDonateItem,
	setModalBuyInventoryItem,
	resetShopState,
} = shopSlice.actions;

export default shopSlice.reducer;
